import script from "./ReportsSync.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsSync.vue?vue&type=script&setup=true&lang=js"

import "./ReportsSync.vue?vue&type=style&index=0&id=73ed5270&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ed5270"]])

export default __exports__